import { getTrackingKey } from '@/utils/api'

import API from './base'

class AuthAPI extends API {
  authenticate = ({ phoneNumber, countryCode, checkoutId, orderId }) => {
    return this.fetcher({
      method: 'POST',
      trackingKey: getTrackingKey(this.uri),
      path: this.uri,
      data: {
        phone_number: phoneNumber,
        country_code: countryCode,
        checkout_id: checkoutId,
        order_id: orderId || '',
      },
    })
  }

  confirm = ({ code, customerId, checkoutId, termsAccepted, fingerprint }) => {
    const data = {
      code,
      customer_id: customerId,
      checkout_id: checkoutId,
      terms_accepted: termsAccepted,
    }

    if (fingerprint) {
      data.fingerprint = fingerprint
    }

    return this.fetcher({
      method: 'POST',
      trackingKey: getTrackingKey(this.uri, 'confirm'),
      path: this.uri + '/confirm',
      data,
    })
  }

  resendOTP = ({
    customerId,
    forceSms = true,
    sameOtp,
    checkoutId = undefined,
    orderId = undefined,
  }) => {
    return this.fetcher({
      method: 'POST',
      trackingKey: getTrackingKey(this.uri, 'resend-otp'),
      path: this.uri + '/resend-otp',
      data: {
        customer_id: customerId,
        force_sms: forceSms,
        same_otp: sameOtp,
        checkout_id: checkoutId,
        order_id: orderId,
      },
    })
  }
}

export default new AuthAPI('/customers/authenticate')
